<nav [attr.aria-labelledby]="ariaLabel()">
  <h2
    *scText="heading()"
    [attr.id]="ariaLabel()"
    class="top-tasks__heading mb-2 mb-lg-4"
  ></h2>
  <div class="row g-2 g-lg-4">
    <ng-content />
  </div>
</nav>
